import LinkedAccountForm from "./LinkedAccountForm";
import {useState} from "react";

const CreateLinkedAccounts = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Linked Accounts", url: "/linked-accounts"},
        {content: "Add Linked Account", url: ""},
    ]);

    return (
        <>
            <LinkedAccountForm crumbs={crumbs} title={"Add Linked Account"} btnText={"Add"}/>
        </>
    )
}
export default CreateLinkedAccounts;